import { LearningBudgetService } from '@/services/learning-budget';
import {
  ApiPaginatedResponse,
  ApiPaginationParams,
  ApiReactQueryOptions,
} from '@/types/api';
import {
  ILearningBudgetTransactionFilters,
  ILearningBudgetTransactionInTheList,
} from '@/types/learning-budget';
import { useQuery } from '@tanstack/react-query';

type UseLearningBudgetTransactionsWithDetailProps = {
  filters?: Omit<ILearningBudgetTransactionFilters, 'digest'>;
  pagination?: ApiPaginationParams;
  options?: ApiReactQueryOptions<
    ApiPaginatedResponse<ILearningBudgetTransactionInTheList>
  >;
};

export function useLearningBudgetTransactionsWithDetail(
  opts?: UseLearningBudgetTransactionsWithDetailProps,
) {
  const { filters, pagination, options } = opts ?? {};

  return useQuery({
    queryKey: [LearningBudgetService.TRANSACTIONS_PATH, filters, pagination],
    queryFn: () =>
      LearningBudgetService.getLearningBudgetTransactionsWithDetail(
        filters,
        pagination,
      ),
    ...options,
  });
}
